<div class="container">

  <app-shared-action-bar [saveReady]="unsavedChanges" [undoReady]="unsavedChanges"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="saveChanges()"
  (undoRequest)="resetUser()"></app-shared-action-bar>

  <div class="px-4 md:px-8 mt-20">
    <div>
      @if (!isGroup) {
        <div class="my-4">
          <h2 class="settings-header">User {{ 'audit' | customerTerm:true }}</h2>
        </div>
      }
      @if (isGroup) {
        <div class="my-4">
          <h2 class="settings-header">Group {{ 'audit' | customerTerm:true }}</h2>
        </div>
      }
      @if (isLoadingUsers) {
        <div>
          <p class="text-lg text-grey-900 mb-4 ">Loading Users...</p>
        </div>
      }
      @if (showUsersDDL && !isLoadingUsers) {
        <div class="mt-4">
          <!--<select class="mt-2 mr-4 text-box xl:w-2/5" [(ngModel)]="selectedUser" (change)="loadUser()">
          <option [disabled]="u.UserID == -1" *ngFor="let u of userListView" [ngValue]="u">{{u.DisplayName}}</option>
        </select>-->
        <div class="flex flex-col-reverse md:flex-row  mt-2">
          <select class=" text-box md:w-2/5 md:mr-2" [(ngModel)]="selectedUser">
            @for (u of userListView; track u) {
              <option [disabled]="u.UserID == -1" [ngValue]="u">
                {{u.DisplayName}}
              </option>
            }
          </select>
          <input type="text" class="text-box w-full  md:w-2/5" [(ngModel)]="userFilterString"
            placeholder="User Search" (keyup)="buildUserView()" />
          </div>
          @if (selectedUser.UserID != -1) {
            <button (click)="loadUser()" class="btn-primary mt-4"
              [disabled]="isLoadingAudits ">@if (!isLoadingAudits) {
              <span>Load</span>
              }@if (isLoadingAudits) {
              <span
              >Loading...</span>
            }</button>
          }
        </div>
      }
      <div>
        @if (!showUsersDDL && selectedUser.UserID!=-1) {
          <div class="mt-4 flex items-center">
            <p class="settings-selected-item mr-2">{{selectedUser.DisplayName}} </p><span (click)="showDDL()"
            class="hover:cursor-pointer text-xl material-symbols-outlined">
            edit
          </span>
        </div>
      }
    </div>
  </div>
  @if (!showUsersDDL) {
    <div class="lg:mx-6 mx-4 my-6">
      <div>
      </div>
      <table>
        <tbody>
          <tr class="border-b-offblack border-b-2 mb-2 py-1">
            <td class="font-bold">All</td>
            <td></td>
            <td class="flex justify-center py-2 pl-3">
              <app-toggle-switch [(checked)]="allPermissions"
              (checkedChange)="updateAllPermissions()"></app-toggle-switch>
            </td>
          </tr>
          @for (p of selectedUser.AuditPermissions; track p) {
            <tr>
              <td>{{p.AuditName}}</td>
              <td>{{p.AuditType}}</td>
              <td class="flex justify-center py-2 pl-3">
                <app-toggle-switch [(checked)]="p.HasPermission" (checkedChange)="checkChange()"
                ></app-toggle-switch>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
</div>
